/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Oscari_S1Inputs */

const en_tut_oscari_s1 = /** @type {(inputs: Tut_Oscari_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the **Orang dan ruang** box in the office sidebar, or press \`⌘K\` / \`Ctrl+K\` and type a person's or a room's name.`)
};

const id_tut_oscari_s1 = /** @type {(inputs: Tut_Oscari_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai kotak **Orang dan ruang** di sidebar kantor, atau tekan \`⌘K\` / \`Ctrl+K\` dan ketik nama orang atau ruang.`)
};

/**
* | output |
* | --- |
* | "Use the **Orang dan ruang** box in the office sidebar, or press `⌘K` / `Ctrl+K` and type a person's or a room's name." |
*
* @param {Tut_Oscari_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_oscari_s1 = /** @type {((inputs?: Tut_Oscari_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Oscari_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_oscari_s1(inputs)
	return en_tut_oscari_s1(inputs)
});